const state = {
    theme: "#1890ff",// 主题
    sideTheme: "#001223", //侧边主题
    logoTheme: "#001c36", //侧边主题
    headerTheme: "#001223", // 头部主题
}


const mutations = {
    CHANGE_THEME: (state, {mainTheme, sideTheme, logoTheme,headerTheme}) => {
        state.theme = mainTheme;
        state.sideTheme = sideTheme;
        state.logoTheme = logoTheme;
        state.headerTheme = headerTheme;
    }
}

const actions = {
    changeTheme({commit}, data) {
        commit('CHANGE_THEME', data)
    }
}
export default {
    // namespaced: true,
    state,
    mutations,
    actions
}
